<powerbi-modal #modalDialog>
    <ng-container>

        <div class="row">

            <div class="col-sm-1">
            </div>
            <div class="col-sm-10">
                <div class="card text-center" style="color: #842029; background-color: #f8d7da; border-color: #f5c2c7">
                    <h2>{{errorPowerBi}}</h2>
                </div>
            </div>
            <div class="col-sm-1">
            </div>

        </div>

        <powerbi-report [embedConfig]="reportConfig" [cssClassName]="reportClass" [phasedEmbedding]="false"
            [eventHandlers]="eventHandlersMap">
        </powerbi-report>
    </ng-container>
</powerbi-modal>